import { Component, OnInit } from '@angular/core';
import { FilterService, PrimeNGConfig } from 'primeng/api';
import { Router, NavigationEnd } from '@angular/router';
import { selectCurrentUser } from './store/user/user.selectors';
import { UserActions } from './store/user/user.actions';
import { Store } from '@ngrx/store';
import { Observable, filter } from 'rxjs';
import { User } from './store/user/user.model';
import { CredentialsService } from './auth/credentials.service';
import { AppUpdateService } from './@shared/app-update.service';
import { registerNameTokensFilter } from './@shared/name-search';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    currentUser$: Observable<User | null>;

    // Public routes that don't require authentication
    private readonly publicRoutes = [
        '/verify-email',
        '/reduction-authorization',
        '/vacation-request-authorization',
        '/notfound',
        '/auth',
        '/personal-requisition-authorization',
        '/assessment-response'
    ];

    constructor(
        private primengConfig: PrimeNGConfig,
        private store: Store,
        private router: Router,
        private credentialsService: CredentialsService,
        private appUpdateService: AppUpdateService,
        private filterService: FilterService
    ) {
        registerNameTokensFilter(this.filterService);

        this.primengConfig.setTranslation({
            dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
            dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
            dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
            monthNames: [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
            ],
            monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
            today: "Hoy",
            clear: "Borrar",
            dateFormat: "dd/mm/yy",
            weekHeader: "Sm",
            firstDayOfWeek: 1
        });
        this.currentUser$ = this.store.select(selectCurrentUser);
    }

    ngOnInit() {
        this.primengConfig.ripple = true;
        this.appUpdateService.startChecking();

        // Only load user if authenticated and not on a public route
        if (this.shouldLoadUser()) {
            this.loadUser();
        }

        // Listen to route changes to load user when navigating from public to private routes
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            if (this.shouldLoadUser()) {
                this.loadUser();
            }
        });
    }

    private shouldLoadUser(): boolean {
        const currentUrl = this.router.url.split('?')[0];
        const isPublicRoute = this.publicRoutes.some(route => currentUrl.startsWith(route));
        const isAuthenticated = this.credentialsService.isAuthenticated();

        // Load user only if authenticated and not on a public route
        return isAuthenticated && !isPublicRoute;
    }

    loadUser() {
        this.store.dispatch(UserActions.getCurrentUser());
    }
}
